// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

const EditableField = props =>
    props.isEditable ?
        props.children :
        <span className={props.className}>
            {props.value}
        </span>;

EditableField.displayName = 'EditableField';
EditableField.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default EditableField;



// WEBPACK FOOTER //
// ./src/shared/components/editable-field/index.js